var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-area-container"},[_c('DataForm',_vm._g({},_vm.$listeners)),_c('h3',[_vm._v(" "+_vm._s(_vm.title)+" "),_c('span',[_vm._v(_vm._s(_vm.subTitle))])]),_c('DataList',{attrs:{"list":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }